export const USER_PROFILE_REQUEST = '@api/USER_PROFILE_REQUEST'
export const USER_PROFILE_SUCCESS = '@api/USER_PROFILE_SUCCESS'
export const USER_PROFILE_ERROR = '@api/USER_PROFILE_ERROR'

export const USER_PROFILE_CLEAN_SUCCESS_REQUEST = '@api/USER_PROFILE_CLEAN_SUCCESS_REQUEST'
export const USER_PROFILE_CLEAN_ERROR_REQUEST = '@api/USER_PROFILE_CLEAN_ERROR_REQUEST'
